import React from "react";
import cx from "classnames";
import UserMenu from "components/common/layouts/appLayout/appSettingBar/UserMenu";
import styles from "components/common/layouts/appLayout/appSettingBar/AppSettingBar.module.scss";

export interface IAppSettingBar {
  className?: string;
}

const AppSettingBar = React.memo(({ className }: IAppSettingBar) => {
  return (
    <div className={cx(styles.root, className)}>
      <span style={{ paddingRight: 20, paddingLeft: 20 }}>
        <b>
          This version of UCCIS has been deprecated! Please visit{" "}
          <a href="https://uccis.rnzcuc.org.nz">https://uccis.rnzcuc.org.nz</a>{" "}
          to access the most recent version
        </b>
      </span>
      <UserMenu />
    </div>
  );
});

export default AppSettingBar;
